// 搜索栏获取参数
class searchReq {
  public pageNo: number;
  public pageSize: number;
  public state: string;
  public recUniversity: string;
  public startDate: string;
  public jobName: string;

  constructor() {
    this.pageNo = 1;
    this.pageSize = 20;
    this.startDate = "";
    this.state = "";
    this.recUniversity = "";
    this.startDate = "";
    this.jobName = "";
  }
}

// 简历列表搜索栏参数
class resumeListReq {
  public pageNo: number;
  public pageSize: number;
  public university: string;
  public specificMajor: string;
  public provinces: string;
  public jobName: string;
  public state: string;
  public major: string;
  public executeState: string;
  public recUniversity: string;

  constructor() {
    this.pageNo = 1;
    this.pageSize = 20;
    this.university = "";
    this.specificMajor = "";
    this.provinces = "";
    this.jobName = "";
    this.state = "";
    this.major = "";
    this.executeState = "";
    this.recUniversity = "";
  }
}
class tabList {
  public value: string;
  public state: string;
  public content: string;

  constructor() {
    this.value = "";
    this.state = "";
    this.content = "";
  }
}

class multipleSelectionReq {
  public id: any;
  public sort: string;
  public phone: string;
  constructor() {
    this.id = "";
    this.sort = "";
    this.phone = "";
  }
}
class interviewReq {
    public id: any;
    public phone: any;
    public content: any;
    public interviewTime: any;
    public interval: any;
    public state: string;
    public interviewer: any;
    constructor() {
      this.id = "";
      this.phone = "";
      this.content = "面试时间：{{sj}} 面试地点：发展大道150号405室 联系人：xxx   1357xxxx  请携带好简历、身份证原件、学位学历证书原件、设计及产品经理岗需携带作品，准时参加面试！  请配合体温等检查！";
      this.interviewTime = "";
      this.state = "8";
      this.interval = "";
      this.interviewer = [];
    }
  }

// 新增行程参数
class addFormData {
  public speechTime: any;
  public university: string;
  public address: string;
  public place: string;
  public regulation: string;
  public startDate: string;

  constructor() {
    this.speechTime = "";
    this.university = "";
    this.address = "";
    this.place = "";
    this.regulation = "";
    this.startDate = "";
  }
}

export { searchReq, addFormData, resumeListReq, tabList, multipleSelectionReq,interviewReq };
